import React, {useEffect, useState, useLayoutEffect} from "react";
import Layout from "../../../components/mobile/Layout/layoutmobileempty";
import {getHotdeal, getHotdealFunction,getHotdealGroup} from "../../../service/hotdealService";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {responsiveproductlistmobile}  from "../../../utils/constant";
import { ItemHotDeal } from "../../../components/mobile/product";
import HeaderMobile from "../../../components/mobile/header/headerv2";
import { pushtracking } from "../../../service/trackingService";
import { useLocation } from "@reach/router";

import './css/index.css';
const Hotdeal=()=> {
    const location = useLocation();
    const uri={
        url :'https://bibomart.com.vn/',
        package : 'vn.com.bibomart.bibomart',
        app_name : 'Bibo Mart',
        app_store_id : '1464298193'
    }
    const [meta, setMeta] = useState();
    const [itemData, setItemData] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [loadMoreStart, setLoadMoreStart] = useState(0);
    const fetchDataHotdeal = (start, group) => {
        let param = {
            div:  null,
            brands: null,
            group: group,
            hotdeal_date: null,
            current_page: start,
            per_page: 6
          };
        try{
            getHotdeal(param).then((response) => {
                if(response.status !== 426 || response.status !== 500 && response.message !== "Không tìm thấy dữ liệu."){
                    if(response.status === 200 && response.message.length >0){
                        setItemData((prevData) => [...prevData, ...response.message]);
                        setTotalItem(response.metadata?.total_item);
                        try{
                            var _sku_list = [];
                            response.message.forEach((item)=>{
                                _sku_list.push(item?.sku);
                            });
                            pushtracking(window.localStorage.getItem('sessionId')??null,
                            window.localStorage.getItem('_id')??null,
                            window.localStorage.getItem('phone')??null ,
                            location.pathname, "Danh sách sản phẩm Hot Deal", 0,0,'index','inWeb',_sku_list,'Website Mobile').then((response)=>{
                                console.log('send tracking');
                            });
                        }catch(e){console.log(e)}
                    }
                }                
              });
        }catch(e){
            console.log(e);
        }
    };

    const [catefunction, setCateFunction] = useState([]);
    const getDataFunction =()=>{
        let param = {
            brands:  ''
          };
        try{
            getHotdealFunction(param).then((response) => {
                if(+response.status === 200 && response.message !== "Không tìm thấy dữ liệu."){
                    setCateFunction(response.message);
                }             
              });
        }catch(e){
            console.log(e);
        }
    }

    const [cateGroup, setCateGroup] = useState([]);
    const getDataGroup =()=>{    
        let param = {
            group:  ''
          };    
        try{
            getHotdealGroup(param).then((response) => {
                console.log(response);
                if(+response.status === 200 && response.message !== "Không tìm thấy dữ liệu."){
                    setCateGroup(response.message);
                }             
              });
        }catch(e){
            console.log(e);
        }
    }
    
    useEffect(()=>{
        setLoadMoreStart(0);
        getDataGroup();
        fetchDataHotdeal(0, null); 
        // getDataFunction();
    },[]);
    const handleClickOnTop=()=>{
        window.scrollTo(0,0);
    }

    const handleLoadMore = (e) => {
        setLoadMoreStart(0);
        const newStart = loadMoreStart + 1;
        setLoadMoreStart(newStart);
        group.length>0? (fetchDataHotdeal(newStart, group)):(fetchDataHotdeal(newStart, null))

      };

  const handleShowAll =()=>{
        setItemData([]);
        setLoadMoreStart(0);
        fetchDataHotdeal(0, null);
        setGroup('');
  }
  const [group, setGroup] = useState('');
  const handleShowByFunction =(group)=>{
    setGroup(group);
    setItemData([]);
    setLoadMoreStart(0);
    fetchDataHotdeal(0, group);
}
const [scrollPosition, setPosition] = useState(0);
    useLayoutEffect(() => {
        function updatePosition() {
          setPosition(window.pageYOffset);
          window.localStorage.setItem("scrollPosition", window.pageYOffset);
        }
        window.addEventListener('scroll', updatePosition);
        updatePosition();

        return () => window.removeEventListener('scroll', updatePosition);
    }, []);
const handleBack=()=>{
    window.history.back();
}

const InfiniteScroll = ({ loadMore }) => {
    useEffect(() => {
      const handleScroll = () => {
        var check = Math.abs(parseInt(window.innerHeight +document.documentElement.scrollTop) - parseInt(document.documentElement.offsetHeight)) 
            if (check === 0 || check === 1) {
            loadMore();
         }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, [loadMore]);
  
    return null;
};
  return (
   <Layout>
              {/* <h1 className='d-none'>Hàng hot deal</h1> */}
    <div className="bg-page" id="hot-deal">
    <HeaderMobile Type={'headerInclude'} showBanner={false} linkBanner="" showText = {true} showSearchIcon= {true} showNoti = {true} showCart = {true} showTitle = {"HOT DEAL"} /> 
            
        <div className="row header-hotdeal">
            <div className="bg-hodeal">
                <img src="/../images/product/22-9-2023-18abc5e2e2c.jpg" alt="icon"/>
            </div>
           
        </div>
    
        <div className= {scrollPosition > 35 ?("row menu-hotdeal pdl-20 list-menu-neo mgx-0 pdy-10"):("row menu-hotdeal pdl-20 pdy-10 bg-white")}>
            <div className="col-1 pdx-0 in-f" onClick={handleShowAll}>
                <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/menu_logo.png" alt="icon"/>
            </div>
            <div className="col-11 pdx-0">
            {
                cateGroup.length > 0 ?(
                    <Carousel key=""
                    responsive={responsiveproductlistmobile}
                    >
                        {
                            cateGroup.map((item, i)=>{
                                return  <div key={i} className="col-3 list-menu-detail" onClick={()=>handleShowByFunction(item?.code)}>
                                <span>{item?.name?.length > 12 ? ( (item?.name).substring(0, 12) +'...') :(item?.name)}</span>
                            </div>
                            })
                        }
                    </Carousel>
                ):(null)
            }
            </div>
        </div>
        
        <div className="row">
            <div className="col-12 item-hotdeal detail-item-hotdeal">
               
                {itemData.length > 0 ?(
                  <ul>
                  {
                         itemData.map((item, i)=>{
                          return <ItemHotDeal item={item} index={i}/>
                         })
                      }
                  </ul> 
            ):(null)}
                <InfiniteScroll loadMore={handleLoadMore} />
            </div>
        </div>
    </div>
    <div className="row">
        <div className="col-12 go-to-top" onClick={handleClickOnTop}>
            <img src="/../images/product/go_to_top.png" alt="icon"/>
        </div>
    </div>
   </Layout>
  )
}
export default Hotdeal;